export default "__VITE_ASSET__BEgOqaz1__"